import React from 'react'
import PropTypes from 'prop-types'

// Components
import RefiVideo from './RefiVideo'
import CospoIntro from '../CospoIntro'

const SyndicatedVideo = ({ videoId, videoType, footerId }) => {
  return (
    <>
      <CospoIntro footerId={footerId}>
        <RefiVideo videoId={videoId} videoType={videoType} />
      </CospoIntro>
    </>
  )
}

SyndicatedVideo.propTypes = {
  videoId: PropTypes.string,
  videoType: PropTypes.string,
  footerId: PropTypes.string
}
export default SyndicatedVideo
